export function getFromQuery(
  key: string,
  query: Record<string, string | string[] | undefined>,
) {
  return key in query ? (query[key] as string) : undefined;
}
